import React from 'react';
import {
  HeaderWrapper,
  HeaderSection,
} from './styled.notLoggedInHeader';
import { INotLoggedInHeader } from './../../../@types/notLoggedInHeader';
import RegisterStepper from '../../../../components/RegisterStepper';

export function NotLoggedInHeader ({
  step = 1,
  isRegistering = false,
  isDeactivatedUser = false,
}: INotLoggedInHeader) {
  return (
    <HeaderWrapper>
      {isRegistering && (
        <HeaderSection>
          <RegisterStepper step={step} isDeactivatedUser={isDeactivatedUser} />
        </HeaderSection>
      )}
    </HeaderWrapper>
  );
}
